import React from 'react';

export const Printer = React.memo(({ fill }) => (
  <>
    <path
      d='M6 8V3C6 2.44772 6.44772 2 7 2H14.5858C14.851 2 15.1054 2.10536 15.2929 2.29289L17.7071 4.70711C17.8946 4.89464 18 5.149 18 5.41421V8H20C21.6569 8 23 9.34315 23 11V16C23 17.1046 22.1046 18 21 18H20V12H4V18H3C1.89543 18 1 17.1046 1 16V11C1 9.34315 2.34315 8 4 8H6Z'
      fill={fill}
    />
    <path
      d='M17 14H7C6.44772 14 6 14.4477 6 15V21C6 21.5523 6.44771 22 7 22H17C17.5523 22 18 21.5523 18 21V15C18 14.4477 17.5523 14 17 14Z'
      fill={fill}
    />
  </>
));
Printer.displayName = 'Printer';
